// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "desinflamacao-1aa2a.firebaseapp.com",
  "projectId": "desinflamacao-1aa2a",
  "storageBucket": "desinflamacao-1aa2a.firebasestorage.app",
  "messagingSenderId": "447780926581",
  "appId": "1:447780926581:web:8f808203d83acda520b43c",
  "measurementId": "G-P3ZL28KSR5",
  "apiKey": "AIzaSyBLLE1Pto71DI4w2omDhnBVz28af_a1Dyo"
};
